import React from 'react';
import Icon from './Icon';
import Reveal from './Reveal';
import './Problem.css';

const PROBLEMS = [
  {
    icon: 'clock',
    title: 'Slow, unreliable delivery',
    text: 'Sending a package across town often means calling around for an okada rider and hoping they show up. No tracking, no accountability.',
  },
  {
    icon: 'shoppingBag',
    title: 'Market women left offline',
    text: 'Food vendors, market women and small grocery sellers have loyal customers but no simple way to take orders and get them delivered digitally, until BikesFood and BikesGroceries.',
  },
  {
    icon: 'package',
    title: 'Fragmented logistics',
    text: 'Small parcels, heavy cargo and campus errands all need separate providers, and none of them talk to each other.',
  },
  {
    icon: 'compass',
    title: 'Riders without steady income',
    text: 'Thousands of capable riders have a bike and the drive to earn, but no single reliable platform connecting them to consistent delivery jobs.',
  },
];

const SOLUTIONS = [
  'One app, BikesDrop, for customers to order through BikesFood, BikesGroceries, or any delivery, errand or cargo move, with live tracking end to end.',
  'One app, BikesDrop Business, for riders, truck drivers and merchants to find jobs, go on standby, list their store and earn, with transparent pricing and a real support system.',
  'One platform tying it all together, powered by real time location, in app chat, and fair, published policies for every side.',
];

export default function Problem() {
  return (
    <section className="problem section" id="why-bikesdrop">
      <div className="container">
        <Reveal className="problem__head">
          <span className="eyebrow eyebrow--teal">The Problem We&rsquo;re Solving</span>
          <h2 className="section-heading">
            Ghana&rsquo;s delivery and logistics scene is fragmented. We&rsquo;re fixing that.
          </h2>
          <p className="section-sub">
            From the busy trotro stations to the quiet halls of a university hostel, moving things
            around Ghana still relies on word of mouth, informal riders and guesswork. BikesDrop
            replaces that with one dependable, technology driven network.
          </p>
        </Reveal>

        <div className="problem__grid">
          {PROBLEMS.map((p, i) => (
            <Reveal delay={i * 80} className="problem__card" key={p.title}>
              <span className="problem__icon">
                <Icon name={p.icon} size={22} />
              </span>
              <h3>{p.title}</h3>
              <p>{p.text}</p>
            </Reveal>
          ))}
        </div>

        <Reveal className="problem__solution">
          <div className="problem__solution-copy">
            <span className="eyebrow eyebrow--amber">Our Solution</span>
            <h3>A single, trusted network for people, businesses and riders</h3>
            <p>
              BikesDrop brings three sides of the same coin, customers, merchants and riders, onto one
              connected platform built for the way Ghana actually moves and trades.
            </p>
          </div>
          <ul className="problem__solution-list">
            {SOLUTIONS.map((s) => (
              <li key={s}>
                <span className="problem__check">
                  <Icon name="check" size={13} strokeWidth={2.4} />
                </span>
                <span>{s}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
